<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn color="dialogBtn" rounded dark class="mb-2 red--text" v-bind="attrs" v-on="on">Select GP</v-btn>
    </template>
    <v-card>
      <v-toolbar color="secondary" class="mb-4">
        <v-toolbar-title>
          Find General Practitioner
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="mt-10">
        <v-form ref="form" v-model="valid" lazy-validation>
          <!-- <v-text-field label="GP's Name (optional)" outlined></v-text-field> -->
          <v-autocomplete label="Surgery Details *"
            outlined
            rounded
            dense
            :loading="isLoading"
            placeholder="Type practice name to search"
            v-model="model" 
            :search-input.sync="search"
            :items="items"
            item-text="practice_name"
            item-value="id"
            :rules="practiceRules"
            clearable
          ></v-autocomplete>
        </v-form>
      </v-card-text>
      <!-- The selected item -->
      <v-card class="ma-2" v-if="selected">
        Your selection:
        <v-card-text class="mb-0"><p><strong>{{ selected.practice_name }}</strong><br>{{ selected.practice_address }}</p>
        <p><span></span>{{ selected.practice_phone }}</p>
        </v-card-text>
      </v-card>
      <v-card-actions>
        <v-btn @click="submit" class="buttons">Save</v-btn>
        <v-spacer></v-spacer>
        <v-btn text @click="dialog = false" color="red">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data: () => ({
    dialog: false,
    valid: true,
    model: null,
    search: null,
    isLoading: false,
    selected: null,
    //rules
    practiceRules: [
      v => !!v || "Please search for a surgery"
    ]
  }),
  computed: {
    ...mapGetters("gp", {
      items: "gAddresses"
    }),
  },
  methods: {
    submit() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch("gp/aUpdate", {id: this.selected.id})
        .then(response => {
          if (response) {
            this.selected = "";
            this.dialog = false;
          }
        })
      }
    }
  },
  watch: {
    search(val) {
      if (val) {
        if (val.length > 3) {
          this.isLoading = true;
          this.$store
            .dispatch("gp/aSearch", val)
            .then(response => {
              if (response) {
                //this.model =  this.search
                this.isLoading = false;
              }
            });
        } else {
          //delete search
          //this.$store.commit("search/mClearSearch");
        }
      }
    },
    model() {
      //this.items.forEach(item => )
      this.selected = this.items.find(item => item.id == this.model)
    }
  }
}
</script>

<style>

</style>